import { gql } from '@apollo/client';

export const getSucursales = gql`
query sucursalApi{
    sucursales(idLocalidadSuc:$idLocalidadSuc,filterBranch:$filterBranch)  
    @rest(type: "Sucursal", path: "/gateway/sucursales/location/branch/{args.idLocalidadSuc}/{args.filterBranch}"){
        cod_ubic
        suc_nombre
    }
}
`   